// Libraries
var React = require('react');

// Components
var VoucherCode = require('../VoucherCode/VoucherCode');
var Dialog = require('../Dialog/Dialog');
var DialogButton = require('../Dialog/DialogButton');

var UtilGuid = require('../../common/utilGuid.js');

// Style
require('./MemberBenefits.scss');

class MemberBenefitsModule extends React.Component {
	constructor(props) {

		super(props);

	}

	render() {
		const onlyOneItemVanilla = !this.props.data.isOneHotspur && this.props.data.benefits.length === 1;
		return (
			<div className={`c-section c-section--always-padded c-section--member-benefits${this.props.data.isOneHotspur ? " c-section--one-hotspur" : ""}`} id={this.props.data.id} data-user-id={this.props.data.userId}>
				<div className="c-section__inner">
					<div className="c-section__inner__inner">
						<div className={`c-member-benefits${onlyOneItemVanilla ? " c-member-benefits--one-item" : ""}${this.props.data.isOneHotspur ? " c-member-benefits--one-hotspur" : ""}`}>
							<div className="c-member-benefits__inner">

								<div className="c-member-benefits__header">
									<h2 className="c-member-benefits__header__title">{this.props.data.title}</h2>
									{(this.props.data.link) &&
										<p className="c-member-benefits__header__button">
											<a href={this.props.data.link} className="c-button c-button--one-hotspur c-button--small">{this.props.data.linkText}</a>
										</p>
									}
								</div>

								{this.props.data.fallbackText ? (
									<p className="c-member-benefits__fallback-text">{this.props.data.fallbackText}</p>
        						) : (
									<div className="c-grid c-grid--center c-grid--member-benefits">
										<div className="c-grid__inner">

											{this.props.data.benefits.map((benefit, index) => {
												const dialogName = 'dialog-' + UtilGuid.guid();
												const dialogAdditionalClass = 'c-dialog--qr-code c-dialog--close-button-outside' + (this.props.data.isOneHotspur ? ' c-dialog--one-hotspur' : '');
												return (
													<div key={index} className={`c-grid__col${onlyOneItemVanilla ? "" : " c-grid__col--4-desktop"}`}>
														<div className="c-grid__col__inner">
															{benefit.image.url && <img src={benefit.image.url} alt={benefit.image.altText} className="c-member-benefits__icon"/>}
															<h3 className="c-member-benefits__title">{benefit.title}</h3>
															{(benefit.description && benefit.description !== '') &&
																<p className="c-member-benefits__description">{benefit.description}</p>
															}
															{!benefit.redeemed && benefit.hasQrCode &&
																<div className="c-member-benefits__qr">
																	<p><DialogButton name={dialogName} additionalClass="c-button c-button--on-dark c-button--small">View QR code</DialogButton></p>
																	<p className="c-member-benefits__or">or</p>
																</div>
															}
															<VoucherCode code={benefit.code} redeemCtaText={benefit.redeemCtaText} redeemed={benefit.redeemed} cta={benefit.cta} businessLine={benefit.businessLine} />
														</div>
														{!benefit.redeemed && benefit.hasQrCode &&
															<Dialog name={dialogName} additionalClass={dialogAdditionalClass}>
																<div className="c-dialog--qr-code__content">
																	<div className="c-dialog--qr-code__code">
																		<div className="c-dialog--qr-code__code-image">
																			<div className="c-dialog--qr-code__code-image-inner">
																				{benefit.qrCodeUrl && <img src={benefit.qrCodeUrl} alt="" />}
																			</div>
																		</div>
																	</div>
																	<div className="c-dialog--qr-code__text">
																		<p className="c-dialog--qr-code__text-title">{benefit.title}</p>
																		<p className="c-dialog--qr-code__text-subtitle">Here's your unique QR code!</p>
																	</div>
																</div>
															</Dialog>
														}
													</div>
												)
											})}

										</div>
									</div>
								)}

							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
};

module.exports = MemberBenefitsModule;


// WEBPACK FOOTER //
// ./src/components/MemberBenefits/MemberBenefits.js